// src/components/ProtectedRoute.jsx
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { session, loading } = useAuth(); // Get session and loading state

  if (loading) {
    // Optional: Show a loading spinner while checking auth state
    return <div className="flex justify-center items-center h-screen"><span className="loading loading-spinner loading-lg"></span></div>;
  }

  if (!session) {
    // User not logged in, redirect to login page
    return <Navigate to="/auth" replace />;
  }

  // User is logged in, render the child component or Outlet
  return children ? children : <Outlet />;
};

export default ProtectedRoute;